import { useServicePermissionsSnapshot } from '../adapters/service';
import { usePermissionsScope } from './PermissionsProvider';

import type { PermissionsSnapshot } from '../core';

/**
 * The port, answered for the scope in context.
 *
 * One derivation remains (R21). The legacy adapter, its mapper and the shadow comparator are gone -
 * scaffolding does not outlive its purpose, and a dormant comparator would have kept resolving two
 * derivations and emitting a telemetry stream for a question already settled.
 *
 * This is still the ONE file in the app that names an adapter, and it stays that way: no call site,
 * component or test above this line knows which one answered (HNS-323). There is no adapter switch
 * any more, so rolling back means reverting the release that removed the legacy one.
 *
 * `MainLayout` is what waits on the answer (KTD10), and only it: routes outside that layout mount no
 * gate and must not pay for one.
 *
 * Not exported from the barrel on purpose: a consumer reading the snapshot directly would bypass
 * `evaluate`, and with it the per-action fact rules that stop, say, an event owner from being handed
 * `report:manage`. `useCan` is the entry point.
 */
export const usePermissionsSnapshot = (): PermissionsSnapshot => useServicePermissionsSnapshot(usePermissionsScope());
